module.exports = {
      id: "6d54bd6624f2de2ce183eac88b5837cbconstruction-stone.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#6d54bd6624f2de2ce183eac88b5837cbconstruction-stone.svg",
      toString: function () {
        return this.url;
      }
    }